import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

// Obtener el registro por id
export const getPricingById = async (id) => {
    const { data } = await axios.get(`${API_ROUTES.PRICING_HOURS}/${id}`);
    return data;
};
// procedimiento actualizar
export const updatePricing = async (id, payload) => {
    const { data } = await axios.put(`${API_ROUTES.PRICING_HOURS}/${id}`, payload);
    return data;
};